module.exports = __webpack_public_path__ + "img/qyfm.baf04910.jpg";